import {
    FETCH_USER_SETTINGS_FETCHING,
    FETCH_USER_SETTINGS_SUCCESS,
    FETCH_USER_SETTINGS_FAIL,
    UPDATE_USER_SETTINGS_UPDATING,
    UPDATE_USER_SETTINGS_SUCCESS,
    UPDATE_USER_SETTINGS_ERROR,
    UPDATE_USER_SETTINGS_MCT_SUCCESS,
    UPDATE_USER_SETTINGS_MCT_ERROR,
    RESET_USER_SETTINGS,
    RESET_USER_SETTINGS_UPDATE,
    FETCH_USER_SETTINGS_DSW_FETCHING,
    FETCH_USER_SETTINGS_DSW_SUCCESS,
    FETCH_USER_SETTINGS_DSW_FAIL,
    UPDATE_USER_SETTINGS_DSW_UPDATING,
    UPDATE_USER_SETTINGS_DSW_SUCCESS,
    UPDATE_USER_SETTINGS_DSW_ERROR
} from '../../actions/ActionTypes';

const INITIAL_STATE = {
    userSettings: null,
    userSettingsFetching: false,
    userSettingsFetchFail: false,
    userSettingsUpdating: false,
    userSettingsUpdateError: false,
    userSettingsFetchFinished: false,
    dsw: {
        workoutTargetTypes: [],
        dswWorkoutTargetTypesFetching: false,
        dswWorkoutTargetTypesFail: false,
        dswWorkoutTargetTypesSuccess: false,
        dswWorkoutTargetTypesUpdating: false,
        dswWworkoutTargetTypesUpdatingFail: false,
        dswWorkoutTargetTypesUpdatingSuccess: false
    }
};

const userSettingsFetching = (state) => {
    return {
        ...state,
        userSettingsFetching: true,
        userSettingsFetchFail: false,
        userSettingsFetchFinished: false
    };
};

const userSettingsFetchFinished = (isSuccess) => (state, action) => {
    return {
        ...state,
        userSettings: isSuccess ? action.userSettings : null,
        userSettingsFetching: false,
        userSettingsFetchFail: !isSuccess,
        userSettingsFetchFinished: true
    };
};

const userSettingsUpdating = (state) => {
    return {
        ...state,
        userSettingsUpdating: true,
        userSettingsUpdateError: false,
        userSettingsFetchFinished: false
    };
};

const userSettingsUpdateFinished = (isSuccess) => (state, action) => {
    return {
        ...state,
        userSettings: {
            ...state.userSettings,
            userData: {
                ...state.userSettings.userData,
                ...action.userSettings
            }
        },
        userSettingsUpdating: false,
        userSettingsUpdateError: !isSuccess,
        userSettingsFetchFinished: true
    };
};

const userSettingsMctUpdateFinished = (isSuccess) => (state, action) => {
    return {
        ...state,
        userSettings: {
            ...state.userSettings,
            userMenstrualCycleSettings: {
                ...state.userSettings.userMenstrualCycleSettings,
                ...action.userMenstrualCycleSettings
            }
        },
        userSettingsUpdating: false,
        userSettingsUpdateError: !isSuccess,
        userSettingsFetchFinished: true
    };
};

const resetUserSettings = () => {
    return INITIAL_STATE;
};

const resetUserSettingsUpdate = (state) => {
    return {
        ...state,
        userSettingsUpdating: false,
        userSettingsUpdateError: false,
        userSettingsFetchFinished: false
    };
};

const dswWorkoutTargetTypesFetching = (state) => {
    return {
        ...state,
        dsw: {
            ...state.dsw,
            dswWorkoutTargetTypesFetching: true
        }
    };
};

const dswWorkoutTargetTypesSuccess = (success) => (state, action) => {
    return {
        ...state,
        dsw: {
            ...state.dsw,
            workoutTargetTypes: action.dswWorkoutTargetTypes,
            dswWorkoutTargetTypesFetching: false,
            dswWorkoutTargetTypesSuccess: success,
            dswWorkoutTargetTypesFail: !success
        }
    };
};

const dswWorkoutTargetTypesUpdating = (state) => {
    return {
        ...state,
        dsw: {
            ...state.dsw,
            dswWorkoutTargetTypesUpdating: true
        }
    };
};

const dswWorkoutTargetTypesUpdatingSuccess = (success) => (state) => {
    return {
        ...state,
        dsw: {
            ...state.dsw,
            dswWorkoutTargetTypesUpdating: false,
            dswWorkoutTargetTypesUpdatingSuccess: success,
            dswWworkoutTargetTypesUpdatingFail: !success
        }
    };
};

export const isDswWorkoutTargetTypesFetching = (state) => {
    return state.userSettings.dsw?.dswWorkoutTargetTypesFetching;
};

export const getDswWorkoutTargetTypes = (state) => {
    return state.userSettings.dsw?.workoutTargetTypes;
};

export const isDswWorkoutTargetTypesFetchingSuccess = (state) => {
    return state.userSettings.dsw?.dswWorkoutTargetTypesSuccess;
};

export const isDswWorkoutTargetTypesFetchingFail = (state) => {
    return state.userSettings.dsw?.dswWorkoutTargetTypesFail;
};

export const isDswWorkoutTargetTypesUpdating = (state) => {
    return state.userSettings.dsw?.dswWorkoutTargetTypesUpdating;
};

export const isDswWorkoutTargetTypesUpdatingSuccess = (state) => {
    return state.userSettings.dsw?.dswWorkoutTargetTypesUpdatingSuccess;
};

export const isDswWorkoutTargetTypesUpdatingFail = (state) => {
    return state.userSettings.dsw?.dswWworkoutTargetTypesUpdatingFail;
};

export const isUserSettingsFetchFinished = (state) => {
    return state.userSettings.userSettingsFetchFinished;
};

export const isUserSettingsFetching = (state) => {
    return state.userSettings.userSettingsFetching;
};

export const isUserSettingsFetchFail = (state) => {
    return state.userSettings.userSettingsFetchFail;
};

export const isUserSettingsUpdating = (state) => {
    return state.userSettings.userSettingsUpdating;
};

export const isUserSettingsUpdateError = (state) => {
    return state.userSettings.userSettingsUpdateError;
};

export const getUserSettings = (state) => {
    return state.userSettings.userSettings;
};

export const getUserMenstrualCycleSettings = (state) => {
    return state.userSettings.userSettings.userMenstrualCycleSettings;
};

const handlers = {
    [FETCH_USER_SETTINGS_FETCHING]: userSettingsFetching,
    [FETCH_USER_SETTINGS_SUCCESS]: userSettingsFetchFinished(true),
    [FETCH_USER_SETTINGS_FAIL]: userSettingsFetchFinished(false),
    [UPDATE_USER_SETTINGS_UPDATING]: userSettingsUpdating,
    [UPDATE_USER_SETTINGS_SUCCESS]: userSettingsUpdateFinished(true),
    [UPDATE_USER_SETTINGS_ERROR]: userSettingsUpdateFinished(false),
    [UPDATE_USER_SETTINGS_MCT_SUCCESS]: userSettingsMctUpdateFinished(true),
    [UPDATE_USER_SETTINGS_MCT_ERROR]: userSettingsMctUpdateFinished(false),
    [RESET_USER_SETTINGS]: resetUserSettings,
    [RESET_USER_SETTINGS_UPDATE]: resetUserSettingsUpdate,
    [FETCH_USER_SETTINGS_DSW_FETCHING]: dswWorkoutTargetTypesFetching,
    [FETCH_USER_SETTINGS_DSW_SUCCESS]: dswWorkoutTargetTypesSuccess(true),
    [FETCH_USER_SETTINGS_DSW_FAIL]: dswWorkoutTargetTypesSuccess(false),
    [UPDATE_USER_SETTINGS_DSW_UPDATING]: dswWorkoutTargetTypesUpdating,
    [UPDATE_USER_SETTINGS_DSW_SUCCESS]: dswWorkoutTargetTypesUpdatingSuccess(true),
    [UPDATE_USER_SETTINGS_DSW_ERROR]: dswWorkoutTargetTypesUpdatingSuccess(false)
};

export default function userSettings(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
